{
  "name": "threatalytics",
  "version": "1.0.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "overrides": {
    "@parcel/watcher": "2.5.1"
  },
  "dependencies": {
    "@amcharts/amcharts5": "^5.3.16",
    "@amcharts/amcharts5-geodata": "^5.1.1",
    "@angular/animations": "^20.0.0",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "aos": "^2.3.4",
    "bootstrap": "^5.3.0",
    "bootstrap-icons": "^1.10.5",
    "eslint": "^8.43.0",
    "html2canvas": "^1.4.1",
    "jquery": "^3.7.0",
    "jspdf": "^3.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^16.3.1",
    "@angular-eslint/eslint-plugin": "16.0.3",
    "@angular-eslint/eslint-plugin-template": "16.0.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "16.0.3",
    "@angular/build": "^20.0.0",
    "@angular/cli": "~20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@types/aos": "^3.0.4",
    "@types/jasmine": "~4.3.0",
    "@types/jest": "^29.5.14",
    "@types/node": "^22.15.29",
    "@typescript-eslint/eslint-plugin": "5.59.7",
    "@typescript-eslint/parser": "5.59.7",
    "eslint": "^8.40.0",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.8.3",
    "zone.js": "^0.15.1"
  }
}
